import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\Mailgun\CreateDomainToMailgunController::__invoke
* @see app/Http/Controllers/ModelNotification/Mailgun/CreateDomainToMailgunController.php
* @route '/api/smtp/domain'
*/
const CreateDomainToMailgunController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDomainToMailgunController.url(options),
    method: 'post',
})

CreateDomainToMailgunController.definition = {
    methods: ["post"],
    url: '/api/smtp/domain',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\Mailgun\CreateDomainToMailgunController::__invoke
* @see app/Http/Controllers/ModelNotification/Mailgun/CreateDomainToMailgunController.php
* @route '/api/smtp/domain'
*/
CreateDomainToMailgunController.url = (options?: RouteQueryOptions) => {
    return CreateDomainToMailgunController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\Mailgun\CreateDomainToMailgunController::__invoke
* @see app/Http/Controllers/ModelNotification/Mailgun/CreateDomainToMailgunController.php
* @route '/api/smtp/domain'
*/
CreateDomainToMailgunController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDomainToMailgunController.url(options),
    method: 'post',
})

export default CreateDomainToMailgunController